export default {"src":"/_next/static/media/Firefox mobile.f840dca3.gif","height":422,"width":918,"blurWidth":0,"blurHeight":0};